exports.data = [
	{
		tab: "Arizona State University",
		role: "Graduate Research/Teaching Associate",
		institute: "Arizona State University",
		instituteLink: "https://www.asu.edu/",
		date: "August 2022 - Present",
		description: [
			"As a research associate, I develop solutions for urban climate research. My work typically involves writing code, running physics-based models on high-performance computing (HPC) clusters, generating datasets, and managing the deployment of these solutions.",
			"As a teaching associate, I conduct recitation sessions, teach, hold office hours, and grade assignments and exams",
		],
	},
	{
		tab: "Enosis Solutions",
		role: "Software Engineer",
		institute: "Enosis Solutions",
		instituteLink: "https://www.enosisbd.com/",
		date: "April 2021 - July 2022",
		description: [
			"Worked on an ad-sales-focused CRM project called Matrix",
			"Collaborated with teams residing in the USA, Mexico, and Thailand",
			"Analyzed client requirements, implemented new features, and fixed bugs reported by the clients",
			"Used C#, F#, AngularJS, MS SQL Server, .NET Framework in the project",
			"Contributed to using Angular 14 for the front end. Implemented internationalization, cookie management, and some components to create a generic table in the Angular app"
		],
	},

	{
		tab: "Sohopathi",
		role: "Junior Software Developer",
		institute: "Sohopathi",
		instituteLink: "https://www.linkedin.com/company/sohopathi-learning-platform/",
		date: "Feb 2020 - Sept 2020",
		description: [
			"Worked as a part-time Junior Software Developer",
			"Developed webapps using MERN Stack",
			"Supervised 5 engineering interns",
			"Developed a Quora-like platform for educational purposes and an examination system",
			"Currently, the company is not operating anymore"
		],
	},
];
